<template>
  <tr class="pricing-table__row">
    <td class="pricing-table__cell pricing-table__cell--xsm">{{ index + 1 }}</td>
    <td class="pricing-table__cell pricing-table__cell--sm">
      <select
        v-model="localTerm"
        @change="setTerm"
      >
        <option 
          v-for="term in termLength"
          :selected="localTerm === term.term"
          :value="term.term"
        >{{ term.term }}-Month</option>
      </select>
    </td>
    <td class="pricing-table__cell pricing-table__cell--smed">
      <select
        v-model="localComponent"
        @change="setComponent"
        :disabled="disableComponent"
      >
        <option 
          v-for="pricingComponent in pricingComponents"
          :selected="localComponent === pricingComponent.id"
          :value="pricingComponent.id"
        >{{ pricingComponent.name }}</option>

        <option 
          :selected="localComponent === 'total'"
          value="total"
        >Total</option>
      </select>
    </td>
    <td class="pricing-table__cell pricing-table__cell--sm">
      <select
        v-model="localTrigger"
        @change="setTrigger"
        :disabled="disableTrigger"
      >
        <option 
          v-for="triggerOption in triggerOptions"
          :value="triggerOption"
          :selected="localTrigger === triggerOption"
        >{{ capitalizeValue(triggerOption) }}</option>
      </select>
    </td>
    <td class="pricing-table__cell pricing-table__cell--sm">
      $0.&nbsp;<input type="text" style="width: 50px; display: inline-block;"
        :id="'trigger-price_' + index + '_' + pricingRequestId"
        :ref="'trigger-price_' + index"
        :value="localTriggerPrice"
        :disabled="disablePrice"
        @input="setTriggerPrice(index, 'trigger-price_' + index)"
      >
    </td>
    <template v-if="localComponent === 'total'">
      <td class="pricing-table__cell pricing-table__cell--sm align-cntr"><div class="pricing-table__val pricing-table__val--input">{{ currentTotalAverage }}</div></td>
    </template>
    <template v-if="localComponent != 'total'">
      <td class="pricing-table__cell pricing-table__cell--sm align-cntr"><div class="pricing-table__val pricing-table__val--input">{{ currentPrice }}</div></td>
    </template>
    <td class="pricing-table__cell pricing-table__cell--xsm">
      <button class="btn btn-tertiary"
        @click="removePricingAlert(index)"
      ><i class="fa fa-times-circle"></i></button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment'
import { capitalize, formatCurrency } from '../../../common/helpers'

export default {
  props: ['index', 'id', 'modalVisible', 'ordinal', 'label', 'facilityProfile', 'pricingData', 'pricingComponents', 'primaryPricingComponent', 'pricingAlerts', 'pricingRequest', 'pricingRequestId', 'termLength', 'term', 'component', 'trigger', 'triggerPrice'],
  data() {
    return {
      optionSetId: 'option-set-' + this._uid,
      maxTriggerPriceDecimalPlaces: 4,
      localTerm: '',
      localComponent: '',
      localTrigger: '',
      localTriggerPrice: '',
      beforeTime: moment('00:00:00 +0000', 'HH:mm:ss Z'),
      afterTime: moment('06:00:00 +0000', 'HH:mm:ss Z'),
    }
  },
  computed: {
    disableComponent() {
      if (!this.localTerm) {
        return true
      }
    },
    disableTrigger() {
      if (!this.localComponent) {
        return true
      }
    },
    disablePrice() {
      if (!this.localTrigger) {
        return true
      }
    },
    triggerOptions() {
      return ['low', 'high']
    },
    currentDate() {
      let utcDate = moment().utc()

      if (utcDate.isBetween(this.beforeTime, this.afterTime)) {
        return moment(utcDate).subtract(1,'d').format('YYYY-MM-DD')
      }

      return moment(utcDate).format('YYYY-MM-DD')
    },
    currentPrice() {
      if (this.localTerm && this.localComponent) {
        let dateIndex = this.currentDate

        if (
          Object.keys(this.pricingData).length && 
          this.pricingData.dates[dateIndex] && 
          this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[this.localComponent]
        ) {
          let averagePrice = 
            this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[this.localComponent][0].avg / 
            this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[this.localComponent][0].term_usage;

          let brokerFee = this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[this.localComponent][0].broker_fee
          if (brokerFee) {
            averagePrice += parseFloat(brokerFee)
          }

          return formatCurrency(averagePrice, 4)
        }
      }

      return '--'
    },
    currentTotalAverage() {
      if (this.localTerm && this.localComponent === 'total') {
        let dateIndex = this.currentDate
        let totalAveragePricePerKwh = 0

        if (
          Object.keys(this.pricingData).length && 
          this.pricingData.dates[dateIndex] && 
          Object.keys(this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components).length
        ) {
          Object.keys(this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components).forEach(key => {
            if (this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[key][0].avg) {
              
              let componentAveragePricePerKwh = 
                this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[key][0].avg / 
                this.pricingData.dates[dateIndex].terms[this.localTerm].pricing_components[key][0].term_usage;

              totalAveragePricePerKwh = (totalAveragePricePerKwh * 1) + (componentAveragePricePerKwh * 1)
            }
          })

          return formatCurrency(totalAveragePricePerKwh, 4)
        }

        return '--'
      }
    }
  },
  methods: {
    removePricingAlert(index) {
      this.$emit('removePricingAlert', index)
    },
    setTriggerPrice(index, ref) {
      let target = this.$refs[ref]
      let val = target.value.replace(/\D/g,'')

      if (val.length <= this.maxTriggerPriceDecimalPlaces) {
        target.value = val
        this.$emit('setTriggerPrice', index, val)
      } else {
        target.value = this.pricingAlerts[index].price
      }
    },
    setTerm() {
      this.$emit('setTerm', this.index, this.localTerm)
    },
    setComponent() {
      let component

      if (this.localComponent === 'total') {
        component = ''
      } else {
        component = this.localComponent
      }

      this.$emit('setComponent', this.index, component)
    },
    setTrigger() {
      this.$emit('setTrigger', this.index, this.localTrigger)
    },
    populateLocalProperties() {
      if (this.term) {
        this.localTerm = this.term
      }

      if (this.component) {
        this.localComponent = this.component
      } else if (this.term && this.trigger && this.triggerPrice) {
        this.localComponent = 'total'
      }

      if (this.trigger) {
        this.localTrigger = this.trigger
      }

      if (this.triggerPrice) {
        this.localTriggerPrice = this.triggerPrice.replace('0.', '')
      }
    },
    capitalizeValue(val) {
      return capitalize(val)
    }
  },
  created() {
    this.populateLocalProperties()
  },
  watch: {
    modalVisible() {
      if (!this.modalVisible) {
        this.populateLocalProperties()
      }
    },
    term() {
      this.populateLocalProperties()
    },
    component() {
      this.populateLocalProperties()
    },
    trigger() {
      this.populateLocalProperties()
    },
    triggerPrice() {
      this.populateLocalProperties()
    },
  }
}
</script>
